import { useTranslation } from '@frontend/i18n';
import { shell } from '@frontend/shell-utils';
import { Button } from '@frontend/design-system';

export const SwitchToLargeModeButton = () => {
  const { t } = useTranslation('analytics');

  return (
    <Button
      onClick={() => {
        shell?.invoke?.('main:update-options', { width: 1500 });
      }}
    >
      {t('Switch to Large Mode')}
    </Button>
  );
};
